<app-main-layout [mainTemplateRef]="main" [requireLogin]="false">
  <ng-template #main>
    <main>
      <article>
        <header>
          @if (!storageWorking || !dbWorking) {
            <mat-icon class="unreachable">signal_wifi_statusbar_connected_no_internet_4</mat-icon>
          }
          @if (storageWorking && dbWorking) {
            <mat-icon class="working">wifi</mat-icon>
          }
        </header>
        <section>
          @if (storageWorking && dbWorking) {
            <h1 class="mat-h1 working">{{ 'uix.502.title.working' | translate }}</h1>
            <p class="flex-centered working">
              <span>{{ 'uix.502.message.working' | translate : { remaining: secondsBeforeRedirect } }}</span>
            </p>
          }
          @if (!storageWorking || !dbWorking) {
            <h1 class="mat-h1 unreachable">{{ 'uix.502.title.unreachable' | translate }}</h1>
            <p class="flex-centered unreachable">
              <span>{{ 'uix.502.message.unreachable' | translate }}</span>
              <a id="serviceDesk-btn" mat-button [href]="supportUrl">
                <mat-icon class="no-margin">help</mat-icon>
                <span>{{ 'uix.502.message.support' | translate }}</span>
              </a>
            </p>
          }

          <a (click)="showTechDetails = !showTechDetails" id="details-link" class="flex-centered">
            {{ 'uix.502.details' | translate }}
            @if (!showTechDetails) {
              <mat-icon>expand_more</mat-icon>
            }
            @if (showTechDetails) {
              <mat-icon>expand_less</mat-icon>
            }
          </a>

          @if (showTechDetails) {
            <section id="details">
              <div class="flex-centered">
                @if (dbWorking === true) {
                  <mat-icon class="working">storage</mat-icon>
                }
                @if (dbWorking === false) {
                  <mat-icon class="unreachable">storage</mat-icon>
                }
                <h4>{{ 'uix.502.db' | translate }}</h4>
              </div>
              <div class="flex-centered">
                @if (storageWorking === true) {
                  <mat-icon class="working">cloud_sync</mat-icon>
                }
                @if (storageWorking === false) {
                  <mat-icon class="unreachable">cloud_sync</mat-icon>
                }
                <h4>{{ 'uix.502.storage' | translate }}</h4>
              </div>
            </section>
          }
        </section>
      </article>
    </main>
  </ng-template>
</app-main-layout>
